// extracted by mini-css-extract-plugin
module.exports = {"base":"LogoHorizontal-base-654a637493c35cdd9117f3733cb950c8","hiddenTitle":"LogoHorizontal-hiddenTitle-3fae90c5f0c69c25775275eaad8b450d"};